import React from 'react';
import { get } from 'lodash';
import { makeStyles } from '@material-ui/core';
import Select from 'react-select';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    flexShrink: 1,
    height: 'fit-content',
    zIndex: 3
  }
}));

function RegionFilter(props) {
  const classes = useStyles();

  return (
    <Select
      id="select-region"
      aria-label="Region Filter"
      className={clsx({
        [classes.root]: !props.className,
        [props.className]: props.className
      })}
      isMulti={props.isMulti ?? false}
      blurOnInputSelect={false}
      closeMenuOnSelect={true}
      isClearable={props.isClearable}
      placeholder={props.placeholder}
      options={[
        { value: 'China', label: 'China' },
        { value: 'America', label: 'America' },
        { value: 'Europe', label: 'Europe' },
        { value: 'Asia', label: 'Asia' },
        { value: 'TW/HK/MO', label: 'TW/HK/MO' }
      ]}
      onChange={props.onChange}
      menuPlacement="auto"
      styles={props.styles ?? undefined}
      components={props.components ?? undefined}
      //show placeholder if no provided value
      value={get(props, 'value.value') ? props.value : null}
      displayEmpty
      menuPortalTarget={document.body}
      menuPosition={'fixed'}
    />
  );
}

RegionFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  className: PropTypes.string,
  isMulti: PropTypes.bool,
  styles: PropTypes.object,
  components: PropTypes.object,
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  value: PropTypes.object
};

RegionFilter.defaultProps = {
  onError: console.error,
  isMulti: false,
  placeholder: 'Region',
  isClearable: true
};

export default RegionFilter;
